export default __webpack_public_path__ + "static/media/showHide.ea352343.svg";